import { toast } from "@babackapp/ui/components/sonner";
import { CheckCircledIcon, CrossCircledIcon } from "@radix-ui/react-icons";

const SuccessIcon = <CheckCircledIcon className="size-4 text-green-400" />;
const ErrorIcon = <CrossCircledIcon className="size-4 text-red-400" />;

type ToastProps = {
  title: string;
  message: string;
  type: "success" | "error";
  toastId: string | number;
};

const typeMap = {
  success: SuccessIcon,
  error: ErrorIcon,
} as const;

export default function FormToast({
  title,
  message,
  type,
  toastId,
}: ToastProps) {
  return (
    <div className="bg-navigation rounded-xl p-4 text-white/80 relative">
      <div className="w-80 flex gap-4">
        {typeMap[type]}
        <div className="flex-col gap-1 flex">
          <span className="font-medium text-xs">{title}</span>
          <p className="text-xs">{message}</p>
        </div>
      </div>
      <button
        type="button"
        onClick={() => toast.dismiss(toastId)}
        className="absolute top-2 right-2 text-white/60"
      >
        <CrossCircledIcon className="size-4" />
      </button>
    </div>
  );
}
